import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { authService } from '@/app/core/auth/auth.service';

/** Allows authenticated users AND guests. Blocks truly unauthenticated visitors. */
export const tabsGuard: CanActivateFn = (_route, state) => {
  if (state.url.startsWith('/tabs/u/')) return true;
  if (authService.isAuthenticated() || authService.isGuest()) return true;
  return inject(Router).createUrlTree(['/login']);
};
